import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CSSBuySheetGuide from "../pages/article/cssbuy-sheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-sheet-guide",
    element: <CSSBuySheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
